import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Loading from 'shared/components/Loading';
import useUser from 'shared/hooks/useUser';
import { useIsPhone } from 'shared/hooks/useMediaQuery';
import { publicRoutes } from 'shared/routes/public-routes';
import styles from './index.module.sass';

// Loaded beside the page's chunk (separate Suspense boundaries), so neither waits for the other
const AppSider = lazy(() => import('../AppSider'));
const MobileTopBar = lazy(() => import('../AppSider/MobileTopBar'));

/**
 * The layout route of the signed-in app: the sider (or the phone top bar) and the current page.
 * It stays mounted across pages, so navigating doesn't rebuild the navigation. Each page wraps its
 * content in `AppLayout`, which waits for the session and profile and owns the page's scroller.
 */
const AppShell = () => {
  // Redirect to login page if user is not connected
  useUser({ redirectTo: publicRoutes.login() });
  const isPhone = useIsPhone();

  return (
    <div className={`flex h-dvh overflow-hidden ${styles.layout}`}>
      {/* Phones get a top bar with a drawer instead of the sider */}
      {!isPhone && (
        <Suspense fallback={null}>
          <AppSider />
        </Suspense>
      )}
      <div className="flex-1 min-w-0 flex flex-col h-full">
        {isPhone && (
          <Suspense fallback={<div className="h-14 shrink-0" />}>
            <MobileTopBar />
          </Suspense>
        )}
        <Suspense fallback={<Loading />}>
          <Outlet />
        </Suspense>
      </div>
    </div>
  );
};

export default AppShell;
